import { Controller } from "stimulus";
import "select2"
import {
    addHtmlElementClass, isValidEmail,
    parseShipmentAddress, removeHtmlChildren,
    removeHtmlElementClass, setHtmlElementValue, setHtmlElementContent,
    veryHighDebouncedFunction
} from "../utils/utils";


export default class extends Controller {
    static targets = [ "ownerEmail", "companyId", "userHomePickUpAddress", "userShipmentAddress", "middleman", "middlemanHomePickUpAddress", "middlemanShipmentAddress", "middlemanDeliveryMethod" ];

    initialize() {
        this.displayUserAddresses();
        this.displayMiddlemenAddresses();
    }




    // Funzione che gestisce il rendering degli indirizzi utente sull'interfaccia grafica
    displayUserAddresses() {
        if (this.ownerEmailTarget.value) {
            removeHtmlElementClass(document, "user-addresses-container", "d-none");
        }
        else
            addHtmlElementClass(document, "user-addresses-container", "d-none");
    }

    // Funzione che gestisce il rendering degli indirizzi dell'aggregatore sull'interfaccia grafica
    displayMiddlemenAddresses() {
        if (this.middlemanTarget.value) {
            removeHtmlElementClass(document, "middleman-addresses-container", "d-none");
        }
        else
            addHtmlElementClass(document, "middleman-addresses-container", "d-none");
    }




    // Funzione che gestisce il cambio dell'email dell'utente proprietario della submission list
    handleChangeUserEmail() {
        setHtmlElementValue(document, "user_id", null);
        setHtmlElementValue(document, "user_home_pick_up_address_id", '');
        setHtmlElementValue(document, "user_shipment_address_id", '');
        veryHighDebouncedFunction(this.checkUserByEmail, [this.ownerEmailTarget.value, this.fillAddressesSelect, this.userHomePickUpAddressTarget, this.userShipmentAddressTarget]);
    }

    // Funzione che chiede al server, mediante richiesta http, l'id e gli indirizzi del nuovo utente proprietario della
    // submission list
    checkUserByEmail(email, fillAddressesSelect, userHomePickUpAddressTarget, userShipmentAddressTarget) {
        if (!email) {
            removeHtmlElementClass(document, "email-outcome", "color-red");
            removeHtmlElementClass(document, "email-outcome", "color-green");
            removeHtmlElementClass(document, "email-outcome", "color-dark-orange");
            setHtmlElementContent(document, "email-outcome", "");

            fillAddressesSelect(userHomePickUpAddressTarget, []);
            fillAddressesSelect(userShipmentAddressTarget, []);
            addHtmlElementClass(document, "user-addresses-container", "d-none");
        } else if (!isValidEmail(email)) {
            addHtmlElementClass(document, "email-outcome", "color-red");
            removeHtmlElementClass(document, "email-outcome", "color-dark-orange");
            removeHtmlElementClass(document, "email-outcome", "color-green");
            setHtmlElementContent(document, "email-outcome", "Invalid User Email!")

            fillAddressesSelect(userHomePickUpAddressTarget, []);
            fillAddressesSelect(userShipmentAddressTarget, []);
            addHtmlElementClass(document, "user-addresses-container", "d-none");
        } else {
            const url = `/backoffice/users/all/check_user_by_email.json?email=${email}&get_user_addresses=true`;

            fetch(url, {
                method: "GET"
            })
              .then((response) => {
                  if (!response.ok)
                      throw Error("An error occour during saving data on the database");
                  else
                      return response.json();
              })
              .then((userData) => {
                  if (userData) {
                      fillAddressesSelect(userHomePickUpAddressTarget, userData.addresses);
                      fillAddressesSelect(userShipmentAddressTarget, userData.addresses);

                      if (userData.user_id) {
                          setHtmlElementValue(document, "user_id", userData.user_id);
                          removeHtmlElementClass(document, "user-addresses-container", "d-none");
                          addHtmlElementClass(document, "email-outcome", "color-green");
                          removeHtmlElementClass(document, "email-outcome", "color-red");
                          removeHtmlElementClass(document, "email-outcome", "color-dark-orange");
                          setHtmlElementContent(document, "email-outcome", "Valid User Email!");
                      } else {
                          addHtmlElementClass(document, "email-outcome", "color-dark-orange");
                          removeHtmlElementClass(document, "email-outcome", "color-red");
                          removeHtmlElementClass(document, "email-outcome", "color-green");
                          setHtmlElementContent(document, "email-outcome", "SHADOW USER!")
                          addHtmlElementClass(document, "user-addresses-container", "d-none");
                      }
                  }
              })
              .catch((error) => {
                  console.error("ERROR:", error);
              });
        }
    }




    // Funzione che gestisce il cambio dell'aggregatore abbinato alla submission list
    handleChangeMiddleman() {
        setHtmlElementValue(document, "middleman_home_pick_up_address_id", null);
        setHtmlElementValue(document, "middleman_shipment_address_id", null);
        setHtmlElementValue(document, "middleman_delivery_method_id", null);
        this.displayMiddlemenAddresses();


        const url = `/backoffice/companies/${this.companyIdTarget.value}/middlemen/get_all_addresses/${this.middlemanTarget.value}`;

        fetch(url, {
            method: "GET"
        })
          .then((response) => {
              if (!response.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return response.json();
          })
          .then((addresses) => {
              this.fillAddressesSelect(this.middlemanHomePickUpAddressTarget, addresses);
              this.fillAddressesSelect(this.middlemanShipmentAddressTarget, addresses);
              this.fillAddressesSelect(this.middlemanDeliveryMethodTarget, []);
          })
          .catch((error) => {
              console.error("ERROR:", error);
          });
    }




    // Funzione che renderizza sull'interfaccia grafica gli indirizzi dell'utente / aggregatore della submission list
    fillAddressesSelect(target, addresses) {
        removeHtmlChildren(target);

        target.insertAdjacentHTML(
          "beforeend",
          "<option value=''>Select address</option>"
        );

        for (const address of addresses) {
            target.insertAdjacentHTML(
              "beforeend",
              `<option value='${address.id}'>` + parseShipmentAddress(address) + "</option>"
            );
        }
    }
}